module.exports = __webpack_public_path__ + "static/media/group.dbe04b98.png";